<template>
  <div class="sign-pg">
    <div class="sign-row">
      <div class="sign-form-top">
        <h2>{{ $t('Забыли пароль') }}</h2>
        <p>{{ $t('Введите E-mail') }}</p>
      </div>
      <form @submit.prevent="sendEmail">
        <div class="form-group">
          <input
            id="username"
            type="text"
            v-model.trim="username"
            class="form-control"
            :class="{
              invalid:
                ($v.username.$dirty && !$v.username.required) ||
                ($v.username.$dirty && !$v.username.email)
            }"
            placeholder="Email"
          />
          <small
            class="helper-text invalid"
            v-if="$v.username.$dirty && !$v.username.required"
          >
            {{ $t('Поле Email не должно быть пустым') }}
          </small>
          <small
            class="helper-text invalid"
            v-else-if="$v.username.$dirty && !$v.username.email"
          >
            {{ $t('Введите коректный Email') }}
          </small>
        </div>
        <button class="btn btn-default grad" type="submit">
          {{ $t('Отправить ссылку для сброса') }}
        </button>
        <div class="sign-form-bottom">
          <div class="no-accaunt">
            <p>{{ $t('Не зарегистрированы') }}?</p>
            <router-link :to="$i18nRoute({ name: 'register' })">{{ $t('Создайте аккаунт сейчас') }}</router-link>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators'
import messages from '@/utils/messages'
import User from '@/model/user'
import { mapMutations } from 'vuex'
import {Trans} from "@/plugins/Translation"

export default {
  name: 'send-email',
  data: () => ({
    username: ''
  }),
  metaInfo () {
    return {
      title: this.$i18n.t('SendEmailTitleSEO'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.$i18n.t('SendEmailDescriptionSEO'),
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.$i18n.t('SendEmailKeywordsSEO'),
      }]
    }
  },
  validations: {
    username: { email, required }
  },
  mounted() {
    if (messages[this.$route.query.message]) {
      this.$message(messages[this.$route.query.message])
    }
  },
  created() {
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    sendEmail() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }
      this.setLoading(true)
      User.sendEmail({ email: this.username })
        .then((response) => {
          const result = response.data
          this.setLoading(false)
          if (result.result == 'success') this.$router.push(Trans.i18nRoute({ name: 'password-reset' }))
        })
        .catch((error) => {
          this.setLoading(false)
          if (error.response.status === 404)
            alert(this.$i18n.t('Пользователь с таким email не найден'))
        })
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
